import { createActions, createState, createReducer } from 'reduxsauce-crud'
import { findIndex, propEq } from 'ramda'

export const CountriesRedux = createActions({
  },
  {
    prefix: 'COUNTRIES_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = CountriesRedux
export const CountriesTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  },
  {
    get: true,
  },
)

export const reducer = createReducer(
  INITIAL_STATE,
  {
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)

const activeCountry = (state) => {
  const classrooms = state.classrooms.get.results
  const countries = state.countries.get.results
  const { activeStudentId, activeClassroomId } = state.classrooms
  const activeClassroomIndex = findIndex(propEq('id', activeClassroomId))(classrooms)

  if (classrooms[activeClassroomIndex]) {
    const activeStudentIndex = findIndex(propEq('id', activeStudentId))(
      classrooms[activeClassroomIndex].students,
    )
    const activeStudent =
      activeStudentIndex > -1
        ? classrooms[activeClassroomIndex].students[activeStudentIndex]
        : undefined

    if (activeStudent) {
      const { country_id } = activeStudent
      return countries.find(country => country.id === country_id)
    }
  }

  return {}
}

const activeParentCountry = (state) =>
  state.countries.get.results.find(country => country.id === state.auth.user.country_id)

export const Selectors = {
  activeCountry,
  activeParentCountry,
}



// WEBPACK FOOTER //
// ./src/Data/Redux/CountriesRedux.js